import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import { AtnGlFilterStore } from '../../store'

@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.input.text.Component,
    ds.input.number.Component,
    ds.input.checkbox.Component,
    ds.input.select.single.Component,
  ],
  selector: 'atn-rate-gl-filter-comparison',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /* --------------------------------- Imports -------------------------------- */

  /**
   * Exposes {@link ents.core.common.value.types.Intrinsic} to the HTML
   */
  public readonly Intrinsic = ents.core.common.value.types.Intrinsic

  /**
   * Exposes {@link ents.core.common.value.Raw} to the HTML
   */
  public readonly RawValue = ents.core.common.value.Raw

  /* ------------------------------- Injections ------------------------------- */

  /** @see {@link AtnGlFilterStore} */
  public readonly store = ngCore.inject(AtnGlFilterStore)

  /* --------------------------------- Inputs --------------------------------- */

  /**
   * {@link ents.extra.rate.gl.Filter.Comparison} being rendered
   */
  public readonly comparisonSg =
    ngCore.input.required<ents.extra.rate.gl.Filter.Comparison>({
      alias: 'comparison',
    })

  /**
   * Identifies this {@link ents.extra.rate.gl.Filter.Comparison} within the
   * current {@link ents.extra.rate.gl.Filter}
   */
  public readonly idSg = ngCore.input.required<string>({
    alias: 'id',
  })

  /* --------------------------------- Outputs -------------------------------- */

  /**
   * Emits changes to this {@link ents.extra.rate.gl.Filter.Comparison}
   */
  public readonly comparisonChange =
    ngCore.output<ents.extra.rate.gl.Filter.Comparison>()

  /* -------------------------------- Computed -------------------------------- */

  /**
   * ID of currently selected attribute
   */
  public attributeIdSg = ngCore.computed(
    (comparison = this.comparisonSg()) => comparison.attributeId,
  )
  /**
   * Currently selected attribute
   */
  public attributeSg = ngCore.computed((attributeId = this.attributeIdSg()) =>
    this.store.glRecordEc.plugins.attributePlugin.feature.selectors
      .getAttribute(attributeId)
      .asSignal(),
  )
  /**
   * Expected value type of the currently selected attribute
   *
   * @see {@link ents.core.common.value.types.Type}
   */
  public attributeValueTypeSg = ngCore.computed(
    (attribute = this.attributeSg()) => attribute?.valueInfo?.type,
  )

  /* -------------------------------- Internals ------------------------------- */

  /**
   * Used for showing delete and edit icons
   */
  public showIconsSg = ngCore.signal(false)

  /* --------------------------------- Methods -------------------------------- */

  /**
   * Use `true` to show icons, and `false` to hide them
   */
  public setIconsVisibility(value: boolean) {
    this.showIconsSg.update(() => value)
  }

  /**
   * TODO:
   */
  public patchComparison(patch: Partial<ents.extra.rate.gl.Filter.Comparison>) {
    const comparison = this.comparisonSg()
    this.comparisonChange.emit({ ...comparison, ...patch })
  }

  /**
   * TODO:
   */
  public setAttributeId(
    attributeId: ents.core.common.Attribute.Id | undefined,
  ) {
    this.patchComparison({
      attributeId: attributeId as ents.core.dms.models.Attribute.Id,
    })
  }
}
